if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

(function keepProductPageAtTopOnLoad() {
  if (!window.location.pathname.includes("/products/")) return;

  let userHasScrolled = false;

  const stopLock = () => {
    userHasScrolled = true;
  };

  window.addEventListener("wheel", stopLock, { passive: true, once: true });
  window.addEventListener("touchmove", stopLock, { passive: true, once: true });
  window.addEventListener("keydown", stopLock, { once: true });

  const scrollTop = () => {
    if (!userHasScrolled) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  };

  scrollTop();

  document.addEventListener("DOMContentLoaded", scrollTop);
  window.addEventListener("pageshow", scrollTop);
  window.addEventListener("load", scrollTop);

  const lockTimer = setInterval(scrollTop, 50);

  setTimeout(() => {
    clearInterval(lockTimer);
  }, 3000);
})();

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector("variant-picker");
      }

      get productMedia() {
        return this.querySelector(
          `[id^="MediaGallery-${this.dataset.section}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productUrl() {
        return this.dataset.url;
      }

      get productId() {
        return this.getAttribute("data-product-id");
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get inventoryStatus() {
        return this.querySelector(`#Inventory-${this.dataset.section}`);
      }

      get sku() {
        return this.querySelector(`#Sku-${this.dataset.section}`);
      }

      get availability() {
        return this.querySelector(`#Availability-${this.dataset.section}`);
      }

      get enableVariantGroupImages() {
        return this.dataset.enableVariantGroupImages === "true" || false;
      }

      get disableDefaultSelectVariant() {
        return this.dataset.disableDefaultSelectVariant === "true" || false;
      }

      get productForm() {
        return this.querySelector("product-form");
      }

      get quantityInput() {
        return this.querySelector("quantity-input input");
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-picker [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      getVariantGroupImages() {
        return (
          JSON.parse(
            this.querySelector('#VariantGroupImages[type="application/json"]')
              .textContent
          ) || {}
        );
      }

      getProductOptionByName(optionName, productData) {
        for (var i = 0; i < productData.options.length; i++) {
          var option = productData.options[i];
          if (option["name"] === optionName) {
            return option;
          }
        }
        return null;
      }

      async getProductData() {
        try {
          const response = await fetch(this.dataset.productUrl + ".js");
          if (!response.ok) {
            throw new Error(
              `Bad HTTP status of the request (${response.status}).`
            );
          }
          const data = await response.json();
          return data;
        } catch (err) {
          console.log(
            `An error occurred while processing the request. Error message: ${err.message}`
          );
        }
      }

      async init() {
        this.onVariantChangeUnsubscriber = window.FoxThemeEvents.subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        if (this.enableVariantGroupImages) {
          this.variantGroupImages = this.getVariantGroupImages();
        }

        this.addEventListener("product-media:loaded", (evt) => {
          if (evt.detail.currentVariant) {
            this.updateMedia(evt.detail.currentVariant);
          }
        });

        const selectedVariantJson = this.productMedia?.querySelector("[data-selected-variant]");
        if (selectedVariantJson) {
          try {
            const selectedVariant = JSON.parse(selectedVariantJson.textContent);
            if (selectedVariant) {
              this.updateMedia(selectedVariant);
            }
          } catch (error) {
            console.warn("Selected variant parse failed", error);
          }
        }

        this.productData = await this.getProductData();
        this.Notification = window.FoxTheme.Notification;

        if (this.productData && this.disableDefaultSelectVariant) {
          this.handleDisableDefaultSelectVariant();
        }
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          __reInitTooltip(newNode);
          window?.Shopify?.PaymentButton?.init();
          console.log("init");
          window?.ProductModel?.loadShopifyXR();
        });
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.init();

        this.initQuantityHandlers();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      handleDisableDefaultSelectVariant() {
        const stickyAtc = document.querySelector(".sticky-atc-bar");
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        if (stickyAtc) {
          stickyAtc.classList.add("f-hidden");
        }

        this.inventoryStatus && this.inventoryStatus.setAttribute("hidden", "");
        this.sku && this.sku.classList.add("hidden");
        this.availability && this.availability.classList.add("hidden");

        let isVariantChange = false;
        this.pickerFields = this.querySelectorAll("[data-picker-field]");

        this.pickerFields &&
          this.pickerFields.forEach((field) => {
            let optionName = field.dataset.optionName;
            let optionInfo = this.getProductOptionByName(
              optionName,
              this.productData
            );

            if (optionInfo && optionInfo.values.length > 1) {
              isVariantChange = true;
              let pickerType = field.dataset.pickerField;
              switch (pickerType) {
                case "select":
                  let selectBox = field.querySelector("select");
                  let option = document.createElement("option");
                  option.text = this.dataset.variantOptionNoneText;
                  option.setAttribute("disabled", "");
                  option.setAttribute("selected", "");

                  selectBox.add(option, 0);
                  break;
                default:
                  let checkedInputs = field.querySelectorAll("input:checked");
                  checkedInputs &&
                    checkedInputs.forEach(function (input) {
                      input.removeAttribute("checked");
                    });
                  break;
              }

              field.dataset.selectedValue = "";
              if (field.querySelector(".selected-value")) {
                field.querySelector(".selected-value").textContent = "";
              }
            }
          });

        if (isVariantChange) {
          document
            .querySelectorAll(
              `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            )
            .forEach((productForm) => {
              const input = productForm.querySelector('input[name="id"]');
              input.value = "";
            });

          const atcButton = this.querySelector('[name="add"]');
          const buyNowButton = this.querySelector(
            ".shopify-payment-button__button"
          );

          atcButton.addEventListener(
            "click",
            this.handleDisableDefaultSelectVariantMessage.bind(this)
          );
          buyNowButton &&
            buyNowButton.addEventListener(
              "click",
              this.handleDisableDefaultSelectVariantMessage.bind(this)
            );
        }
      }

      handleDisableDefaultSelectVariantMessage(evt) {
        if (!this.currentVariant) {
          evt.preventDefault();
          this.pickerFields &&
            this.pickerFields.forEach((pickerField) => {
              if ("" === pickerField.dataset.selectedValue) {
                pickerField
                  .closest(".variant-picker__field-wrapper")
                  .classList.add("is-error");
              }
            });

          this.Notification.show({
            target: this.productForm,
            method: "appendChild",
            type: "warning",
            last: 3000,
            message: this.dataset.variantSelectionNeededText,
          });
        }
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.productUrl;
        const shouldSwapProduct = this.dataset.productUrl !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";

          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            const currentShareModal = document.getElementById(
              `PopupModal-Sharing-${this.sectionId}`
            );
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;
            if (currentShareModal) document.body.removeChild(currentShareModal);

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById("shopify-section-sticky-atc-bar"),
              html.getElementById("shopify-section-sticky-atc-bar"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);
          this.toolTip = __reInitTooltip(this);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.sectionId}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.removeAttribute("hidden");
            }
          };

          updateSourceFromDestination("Price");
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("PricePerItem");
          updateSourceFromDestination("Inventory");
          updateSourceFromDestination("Sku");
          updateSourceFromDestination("Availability");

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination("QuantityRules");
          updateSourceFromDestination("QuantityRulesCart");
          updateSourceFromDestination("VolumeNote");

          const addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${this.sectionId}`
          );
          this.updateButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            window.FoxThemeStrings.soldOut
          );
          this.currentVariant = variant;

          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.variantChange, {
            data: { variant, sectionId: this.sectionId, html },
          });

          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        const scrollTop = window.scrollY;

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            requestAnimationFrame(() => {
              window.scrollTo(0, scrollTop);
            });

            // 不再自动聚焦，避免选择颜色后页面滚动
            // document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-picker");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(
          `ShareButton-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${variantId}`
        );
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          )
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
      }

      updateButton(disable = true, text) {
        const productForm = document.getElementById(
          `product-form-${this.sectionId}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );

        if (!addButton) return;
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }

      normalizeOptionText(value) {
        return (value || "")
          .toString()
          .toLowerCase()
          .replace(/&amp;/g, "&")
          .replace(/\s+/g, " ")
          .trim();
      }

      getProductOptionNames() {
        if (!this.productData || !this.productData.options) return [];

        return this.productData.options.map((option) => {
          return typeof option === "string" ? option : option.name || "";
        });
      }

      getColorOptionIndex() {
        const colorOptionNames = ["color", "colour", "颜色", "色"];
        const optionNames = this.getProductOptionNames();

        const colorOptionIndex = optionNames.findIndex((optionName) => {
          const normalizedName = this.normalizeOptionText(optionName);
          return colorOptionNames.some((name) => normalizedName.includes(name));
        });

        // 产品数据还没加载完时，先默认第 1 个属性就是 Color
        return colorOptionIndex > -1 ? colorOptionIndex : 0;
      }

      getVariantOptionValue(variant, optionIndex) {
        if (!variant || optionIndex < 0) return "";

        return (
          variant.options?.[optionIndex] ||
          variant[`option${optionIndex + 1}`] ||
          ""
        );
      }

      getVariantMediaId(variant) {
        return (
          variant?.featured_media?.id ||
          variant?.featured_media_id ||
          variant?.featured_image?.id ||
          variant?.image?.id ||
          null
        );
      }

      getVariantDataForMediaFilter() {
        if (this.productMedia?.variantData?.length) {
          return this.productMedia.variantData;
        }

        const variantJson = this.productMedia?.querySelector(
          'script[type="application/json"]'
        );

        if (!variantJson) return [];

        try {
          return JSON.parse(variantJson.textContent) || [];
        } catch (error) {
          return [];
        }
      }

      getMediaIdsForSelectedColor(variant) {
        const colorOptionIndex = this.getColorOptionIndex();
        const selectedColor = this.normalizeOptionText(
          this.getVariantOptionValue(variant, colorOptionIndex)
        );
        const variants = this.getVariantDataForMediaFilter();

        if (colorOptionIndex < 0 || !selectedColor || !variants.length) {
          return null;
        }

        const allAssignedMediaIds = new Set();
        const selectedColorMediaIds = new Set();

        variants.forEach((item) => {
          const mediaId = this.getVariantMediaId(item);
          if (!mediaId) return;

          const mediaIdString = mediaId.toString();
          allAssignedMediaIds.add(mediaIdString);

          const itemColor = this.normalizeOptionText(
            this.getVariantOptionValue(item, colorOptionIndex)
          );

          if (itemColor === selectedColor) {
            selectedColorMediaIds.add(mediaIdString);
          }
        });

        if (!selectedColorMediaIds.size) return null;

        return {
          selectedColorMediaIds,
          allAssignedMediaIds,
        };
      }

      filteredMediaForSelectedColor(items, variant) {
        const mediaGroups = this.getMediaIdsForSelectedColor(variant);

        if (!mediaGroups) return null;

        const currentVariantMediaId = this.getVariantMediaId(variant)?.toString();

        const currentVariantResults = [];
        const selectedColorResults = [];
        const commonResults = [];
        const otherResults = [];

        items.forEach((item) => {
          const mediaId = item.dataset.mediaId;
          const mediaType = item.dataset.mediaType;

          if (mediaType && mediaType !== "image") {
            otherResults.push(item);
            return;
          }

          if (currentVariantMediaId && mediaId === currentVariantMediaId) {
            currentVariantResults.push(item);
            return;
          }

          if (mediaGroups.selectedColorMediaIds.has(mediaId)) {
            selectedColorResults.push(item);
            return;
          }

          if (!mediaGroups.allAssignedMediaIds.has(mediaId)) {
            commonResults.push(item);
          }
        });

        const results = [
          ...currentVariantResults,
          ...selectedColorResults,
          ...commonResults,
          ...otherResults,
        ];

        results.forEach((item, index) => {
          item.dataset.index = index;
        });

        return results;
      }
      
      updateFilteredMediaCounter(total) {
        const currentCounter = this.productMedia.querySelector(
          ".flickity-counter--current"
        );
        const totalCounter = this.productMedia.querySelector(
          ".flickity-counter--total"
        );

        if (currentCounter) {
          currentCounter.textContent = "1";
        }

        if (totalCounter) {
          totalCounter.textContent = total;
        }
      }

      updateMediaBySelectedColor(variant) {
        if (!this.productMedia || !variant) return false;

        const mainMedia = this.productMedia.querySelector(".f-product__media-list");
        const thumbMedia = this.productMedia.querySelector(".f-product__media-thumbnails");

        if (!mainMedia || !this.productMedia.domNodes?.medias) return false;

        const mediaToShow = this.filteredMediaForSelectedColor(
          this.productMedia.domNodes.medias,
          variant
        );

        if (!mediaToShow || !mediaToShow.length) return false;

        mainMedia.classList.toggle("f-product__media-list--single-filtered", mediaToShow.length === 1);
        this.productMedia.classList.toggle("media-gallery--single-filtered", mediaToShow.length === 1);
        document.body.classList.toggle("single-variant-image",mediaToShow.length === 1);

        this.updateFilteredMediaCounter(mediaToShow.length);

        const isCarousel = !!this.productMedia.querySelector(".flickity-slider");

        if (isCarousel) {
          const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);
          if (!mainFlickity) return false;

          mainMedia.querySelectorAll(".f-product__media").forEach((slide) => {
            mainFlickity.remove(slide);
          });

          mediaToShow.forEach((slide, index) => {
            const zoomButton = slide.querySelector(".js-photoswipe--zoom");

            if (zoomButton) {
              zoomButton.setAttribute("data-media-index", index);
            }

            slide.setAttribute("data-media-index", index);
            slide.setAttribute("data-index", index);
            mainFlickity.append(slide);
          });

          if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
            const thumbnailsFlickity = window.FoxTheme.Flickity.data(thumbMedia);

            if (thumbnailsFlickity) {
              thumbMedia
                .querySelectorAll(".f-product__media-thumbnails-item")
                .forEach((slide) => {
                  thumbnailsFlickity.remove(slide);
                });

              const thumbsToShow = this.filteredMediaForSelectedColor(
                this.productMedia.domNodes.thumbnailItems,
                variant
              );

              thumbsToShow.forEach((slide, index) => {
                slide.setAttribute("data-thumbnail-index", index);
                slide.setAttribute("data-index", index);
                thumbnailsFlickity.append(slide);
              });

              thumbMedia.classList.remove(
                "disable-transition",
                "md:disable-transition"
              );

              if (thumbsToShow.length < 5) {
                thumbMedia.classList.add("disable-transition");
              }

              if (thumbsToShow.length < 6) {
                thumbMedia.classList.add("md:disable-transition");
              }

              thumbnailsFlickity.option({
                wrapAround: thumbsToShow.length > 5,
              });
              thumbnailsFlickity.reloadCells();
              thumbnailsFlickity.reposition();
            }
          }

          mainFlickity.reloadCells();
          mainFlickity.reposition();
          mainFlickity.select(0, false, false);
        } else {
          const mediaToShowSet = new Set(mediaToShow);

          this.productMedia.domNodes.medias.forEach((item) => {
            const shouldShow = mediaToShowSet.has(item);

            item.style.display = shouldShow ? "" : "none";
          });

          mediaToShow.forEach((item, index) => {
            const zoomButton = item.querySelector(".js-photoswipe--zoom");

            if (zoomButton) {
              zoomButton.setAttribute("data-media-index", index);
            }

            item.setAttribute("data-media-index", index);
            item.setAttribute("data-index", index);
            item.style.order = index;
          });
        }

        if (this.productMedia.enableZoom) {
          this.productMedia.lightbox && this.productMedia.lightbox.destroy();
          this.productMedia.initImageZoom();
        }

        this.productMedia.removeAttribute("data-media-loading");

        return true;
      }

      updateMedia(variant) {
        if (!this.productMedia) return;

        if (this.updateMediaBySelectedColor(variant)) {
          return;
        }

        if (this.variantGroupImages && this.variantGroupImages.enable) {
          const isCarousel = this.productMedia.querySelector(".flickity-slider")
            ? true
            : false;
          const initalMediaIds = this.productMedia?.domNodes?.medias.map(
            (item) => item.dataset.mediaId
          );
          const groupImages = this.variantGroupImages.mapping.find(
            (item) => Number(item.id) === variant.id
          );
          const currentVariantMedia = groupImages
            ? groupImages.media
            : this.allMediaIds;

          if (!this.areArraysEquivalent(currentVariantMedia, initalMediaIds)) {
            const mainMedia = this.productMedia.querySelector(
              ".f-product__media-list"
            );
            const thumbMedia = this.productMedia.querySelector(
              ".f-product__media-thumbnails"
            );
            if (isCarousel) {
              const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);

              let mediaToRemove =
                mainMedia.querySelectorAll(".f-product__media");
              mediaToRemove &&
                mediaToRemove.forEach(function (slide) {
                  mainFlickity.remove(slide);
                });
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );

              mediaToShow.forEach(function (slide, index) {
                const zoomButton = slide.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                slide.setAttribute("data-media-index", index);
                slide.setAttribute("data-index", index);
                mainFlickity.append(slide);
              });

              if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
                const thumbnailsFlickity =
                  window.FoxTheme.Flickity.data(thumbMedia);

                let thumbsToRemove = thumbMedia.querySelectorAll(
                  ".f-product__media-thumbnails-item"
                );
                thumbsToRemove &&
                  thumbsToRemove.forEach(function (slide) {
                    thumbnailsFlickity.remove(slide);
                  });

                let thumbsToShow = this.filteredMediaForSelectedVariant(
                  this.productMedia.domNodes.thumbnailItems,
                  currentVariantMedia
                );
                thumbsToShow.forEach(function (slide, index) {
                  slide.setAttribute("data-thumbnail-index", index);
                  slide.setAttribute("data-index", index);
                  thumbnailsFlickity.append(slide);
                });

                thumbMedia.classList.remove(
                  "disable-transition",
                  "md:disable-transition"
                );
                if (thumbsToShow.length < 5) {
                  thumbMedia.classList.add("disable-transition");
                }
                if (thumbsToShow.length < 6) {
                  thumbMedia.classList.add("md:disable-transition");
                }
                thumbnailsFlickity.option({
                  wrapAround: thumbsToShow.length > 5,
                });
                thumbnailsFlickity.reloadCells();
                thumbnailsFlickity.reposition();
              }

              mainFlickity.select(0, false, false);
            } else {
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );
              mainMedia.innerHTML = "";
              mediaToShow.forEach((item, index) => {
                const zoomButton = item.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                item.setAttribute("data-media-index", index);
                item.setAttribute("data-index", index);
                mainMedia.append(item);
              });
            }

            // Re-init Photoswipe
            if (this.productMedia && this.productMedia.enableZoom) {
              this.productMedia.lightbox &&
                this.productMedia.lightbox.destroy();
              this.productMedia.initImageZoom();
            }
          }

          this.productMedia.removeAttribute("data-media-loading");
        } else {
          if (!variant.featured_media) return;
          if (typeof this.productMedia.setActiveMedia === "function") {
            this.productMedia.setActiveMedia(variant.featured_media.id);
          }
        }
      }

      setUnavailable() {
        this.updateButton(true, window.FoxThemeStrings.unavailable);

        const selectors = [
          "Price",
          "Inventory",
          "Sku",
          "PricePerItem",
          "VolumeNote",
          "Volume",
          "QuantityRules",
          "QuantityRulesCart",
        ]
          .map((id) => `#${id}-${this.sectionId}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach((selector) => selector.setAttribute("hidden", ""));
      }

      areArraysEquivalent(firstArray, secondArray) {
        if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
          return false;
        }

        if (firstArray.length !== secondArray.length) {
          return false;
        }

        const sortedFirstArray = [...firstArray].sort();
        const sortedSecondArray = [...secondArray].sort();

        return sortedFirstArray.every(
          (value, index) => value === sortedSecondArray[index]
        );
      }

      filteredMediaForSelectedVariant(items, currentVariantMedia) {
        let index = 0;
        let prioritizedResults = [];
        let otherResults = [];
        items.forEach((item) => {
          const dataIdMedia = item.dataset.mediaId;
          if (currentVariantMedia && currentVariantMedia.length > 0) {
            if (currentVariantMedia.includes(dataIdMedia)) {
              item.dataset.index = index++;
              prioritizedResults.push(item);
            }

            if (item.dataset.mediaType !== "image") {
              item.dataset.index = index++;
              otherResults.push(item);
            }
          } else {
            item.dataset.index = index++;
            prioritizedResults.push(item);
          }
        });

        const sortByVariantOrder = (a, b) => {
          const indexA = currentVariantMedia.indexOf(a.dataset.mediaId);
          const indexB = currentVariantMedia.indexOf(b.dataset.mediaId);
          return indexA - indexB;
        };

        prioritizedResults.sort(sortByVariantOrder);

        const results = [...prioritizedResults, ...otherResults];

        return results;
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute("data-original-section-id")) {
          this.cartUpdateUnsubscriber = FoxThemeEvents.subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        fetch(
          `${this.getAttribute(
            "data-product-url"
          )}?variant=${currentVariantId}&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(
              this.sectionId,
              this.productId,
              parsedHTML
            );
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}

/* ==========================================================================
   100% 稳定监控：直接锁定【Add to Cart 购买按钮】，滚出屏幕上方后显现浮动条
   ========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  // 1. 把外层容器和内层浮动条全部获取到（防止漏网之鱼）
  const stickyBars = document.querySelectorAll("#shopify-section-sticky-atc-bar, .sticky-atc-bar");
  
  // 2. 核心靶心：直接获取网页上用户点击加购的那个具体按钮 (button[name="add"])！
  const targetBtn = document.querySelector('button[name="add"]') || document.querySelector(".f-product-single__block--buy_buttons") || document.querySelector("product-form");

  // 如果页面找不到按钮或浮动条，则不执行
  if (!stickyBars.length || !targetBtn) return;

  let isScheduled = false;
  function checkButtonVisibility() {
    // 获取当前加购按钮在浏览器窗口里的坐标
    const rect = targetBtn.getBoundingClientRect();
    
    // 关键判断：当加购按钮的底部边缘 (rect.bottom) 小于 0，说明主加购按钮已经完全滚到屏幕上方看不见了！
    if (rect.bottom < 0) {
      // 打开总开关，唤醒所有层级的浮动条
      document.body.classList.add("show-sticky-atc");
      stickyBars.forEach(bar => bar.classList.add("sticky-atc-visible"));
    } else {
      // 只要页面上还能看得到原本的购买按钮，底部的浮动条就自动缩回隐藏
      document.body.classList.remove("show-sticky-atc");
      stickyBars.forEach(bar => bar.classList.remove("sticky-atc-visible"));
    }
    isScheduled = false;
  }

  function onScroll() {
    if (!isScheduled) {
      isScheduled = true;
      requestAnimationFrame(checkButtonVisibility);
    }
  }

  // 监听浏览器滚动与屏幕尺寸变化
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  
  // 延迟 150 毫秒做第一次初检，保证页面图片加载完、坐标固定后再执行
  setTimeout(checkButtonVisibility, 150);
});